import React from 'react';
import { useSelector } from 'react-redux';

export const PageInformation = () => {
	const { richSnippetText } = useSelector((state) => state);

	if (richSnippetText) {
		return (
			<div
				className="px-2 md:mt-8 text-body-xs font-bold md:text-title"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: richSnippetText }}
			/>
		);
	}

	return null;
};

export default PageInformation;
